import { create } from "zustand";

const useVersionStore = create((set) => ({
  latestVersion: null,
  setLatestVersion: (version) => set({ latestVersion: version }),
}));

export default useVersionStore;
